import type { IntegrationRequestStep } from '../../../../../models/IntegrationRun';
import { describeStepDetail } from '../../../utils/describeStepDetail';
import { formatDate } from '@/utils/dates';
import { useState } from 'react';

export type IntegrationStepView = 'pending' | 'running' | IntegrationRequestStep['state'];

const STATE_STYLES: Record<IntegrationStepView, { label: string; className: string }> = {
  ok: { label: 'OK', className: 'bg-green-50 text-green-700 border-green-200' },
  failed: { label: 'Falló', className: 'bg-red-50 text-red-700 border-red-200' },
  skipped: { label: 'Omitido', className: 'bg-gray-50 text-gray-600 border-gray-200' },
  running: { label: 'En curso…', className: 'bg-blue-50 text-blue-700 border-blue-200' },
  pending: { label: 'Pendiente', className: 'bg-white text-gray-500 border-gray-200' },
};

interface IntegrationStepItemProps {
  label: string;
  view: IntegrationStepView;
  step?: IntegrationRequestStep;
}

const IntegrationStepItem = ({ label, view, step }: IntegrationStepItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const lines = step ? describeStepDetail(step) : [];
  const style = STATE_STYLES[view];

  return (
    <li className='flex flex-col gap-1 border-b border-gray-100 py-2 last:border-b-0'>
      <div className='flex flex-wrap items-center gap-3'>
        <span className={`rounded-full border px-2.5 py-0.5 text-xs font-medium ${style.className}`}>
          {style.label}
        </span>
        <span className='text-sm text-gray-800'>{label}</span>
        {step?.at && (
          <span className='text-xs text-gray-500'>
            {formatDate(step.at)}
            {step.by ? ` · ${step.by}` : ''}
          </span>
        )}
        {lines.length > 0 && (
          <button
            type='button'
            className='text-xs text-orange-600 hover:underline'
            onClick={() => setIsOpen((open) => !open)}
          >
            {isOpen ? 'Ocultar detalle' : 'Ver detalle'}
          </button>
        )}
      </div>
      {step?.error && <p className='text-sm text-red-700'>{step.error}</p>}
      {isOpen && (
        <ul className='ml-4 list-disc text-xs text-gray-700'>
          {lines.map((line, index) => (
            <li key={`${step?.id}-${index}`}>{line}</li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default IntegrationStepItem;
